import { FC } from 'react';

import { Card, FullPageContainer, Table, useBreakpoint } from '@hh.ru/magritte-ui';

import { WizardVacanciesTableBody } from 'components/CampaignCreationWizard/VacancySelectStep/components/VacancyListTab/WizardVacanciesTable/WizardVacanciesTableBody/WizardVacanciesTableBody';
import { WizardVacanciesTableHeader } from 'components/CampaignCreationWizard/VacancySelectStep/components/VacancyListTab/WizardVacanciesTable/WizardVacanciesTableHeader/WizardVacanciesTableHeader';

import styles from 'components/CampaignCreationWizard/VacancySelectStep/components/VacancyListTab/WizardVacanciesTable/WizardVacanciesTable.module.less';

export const WizardVacanciesTable: FC = () => {
    const { isMobile } = useBreakpoint();

    return (
        <FullPageContainer>
            {({ paddingLeft, paddingRight }) => (
                <Card stretched>
                    {!isMobile ? (
                        <div className={styles.tableWrapper} data-qa="wizard-vacancies-table">
                            <Table
                                stickyHeader
                                divider
                                dividerTop={false}
                                paddingLeft={paddingLeft}
                                paddingRight={paddingRight}
                                cellsGap={48}
                            >
                                <WizardVacanciesTableHeader />
                                <WizardVacanciesTableBody paddingLeft={paddingLeft} paddingRight={paddingRight} />
                            </Table>
                        </div>
                    ) : (
                        <WizardVacanciesTableBody paddingLeft={paddingLeft} paddingRight={paddingRight} />
                    )}
                </Card>
            )}
        </FullPageContainer>
    );
};
